import { Theme, css } from '@emotion/react';

import { Radius, Spacing, Typography } from 'chatie-design-system';
import { ArrowRight, Icon } from 'chatie-design-system/icon';

import { LiveSession } from '@api/live';
import { CSSProps } from '@utils/misc';
import { useWebView } from '@utils/webview';

const cardCSS = (theme: Theme) => css`
  display: flex;
  align-items: center;
  gap: ${Spacing.small}px;
  margin: ${Spacing.small}px ${Spacing.medium}px ${Spacing.medium}px;
  padding: ${Spacing.medium}px;
  border: 1px solid ${theme.colors.red500}33;
  border-radius: ${Radius.medium}px;
  background: ${theme.name === 'dark'
    ? `linear-gradient(135deg, ${theme.colors.red500}1f, ${theme.var.white})`
    : `linear-gradient(135deg, ${theme.colors.red50}, ${theme.var.white})`};
  cursor: pointer;

  .content {
    min-width: 0;
    flex: 1;
  }

  .title {
    display: block;
    margin-top: ${Spacing.xsmall}px;
  }

  .description {
    display: block;
    ${Typography.body12};
    color: ${theme.var.gray500};
    margin-top: ${Spacing.xxsmall}px;
  }
`;

const badgeCSS = (theme: Theme) => css`
  ${Typography.body11};
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: ${theme.colors.red500};
  font-weight: 700;

  &::before {
    content: '';
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background-color: ${theme.colors.red500};
  }
`;

type Props = {
  session: LiveSession;
};

const LiveSessionCard = ({ className, session }: Props & CSSProps) => {
  const { openPageOrMove } = useWebView();

  return (
    <button
      type="button"
      css={cardCSS}
      className={className}
      onClick={() => void openPageOrMove(`/lives/${session.id}`)}
    >
      <div className="content">
        <span css={badgeCSS}>LIVE</span>
        <strong className="title ellipsis">
          {session.title || '작가와 실시간으로 이야기해요'}
        </strong>
        <span className="description">지금 라이브에 참여해보세요.</span>
      </div>
      <Icon icon={ArrowRight} />
    </button>
  );
};

export default LiveSessionCard;
